module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "TokenFarm_symbol.b82b4f01.png";